import jwtAxios from '@nxsys/services/axios';
import { endPoints } from '@nxsys/services/endpoints';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  GetAgencyUploadListParams,
  GetAgencyUploadListResponse,
  GetImportAgencyListParams,
  GetImportAgencyListResponse,
  GetImportEmployeeListParams,
  GetImportEmployeeListResponse,
  GetImportProspectListParams,
  GetImportProspectListResponse,
  GetImportTimesheetListParams,
  GetImportTimesheetListResponse,
} from '../types';

export const getImportAgencyList = createAsyncThunk<
  GetImportAgencyListResponse,
  GetImportAgencyListParams
>(
  'import/getImportAgencyList',
  async (params: GetImportAgencyListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.import.getAgency, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getImportEmployeeList = createAsyncThunk<
  GetImportEmployeeListResponse,
  GetImportEmployeeListParams
>(
  'import/getImportEmployeeList',
  async (params: GetImportEmployeeListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.import.getSub, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getImportProspectList = createAsyncThunk<
  GetImportProspectListResponse,
  GetImportProspectListParams
>(
  'import/getImportProspectList',
  async (params: GetImportProspectListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.import.getProspect, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getImportTimesheetList = createAsyncThunk<
  GetImportTimesheetListResponse,
  GetImportTimesheetListParams
>(
  'import/getImportTimesheetList',
  async (params: GetImportTimesheetListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.import.getTimeSheet, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getAgencyUploadList = createAsyncThunk<
  GetAgencyUploadListResponse,
  GetAgencyUploadListParams
>(
  'import/getAgencyUploadList',
  async (params: GetAgencyUploadListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.import.agencyUpload, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getAgencyUploadSummary = createAsyncThunk(
  'import/getAgencyUploadSummary',
  async (_, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(
        `${endPoints.import.agencyUpload}/summary`,
      );
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const importActs = {
  getImportAgencyList,
  getImportEmployeeList,
  getImportProspectList,
  getImportTimesheetList,
  getAgencyUploadList,
  getAgencyUploadSummary,
};
